import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// import components to route to
import { BookingSectionComponent } from './containers/booking-section/booking-section.component';
import { StepLocationComponent } from './containers/step-location/step-location.component';
import { StepTimeComponent } from './containers/step-time/step-time.component';
import { StepPaymentComponent } from './containers/step-payment/step-payment.component';
import { D2dBookingSwitchComponent } from './components/d2d-booking-switch/d2d-booking-switch.component';
import { StepHubDropComponent } from './containers/step-hub-drop/step-hub-drop.component';

const bookingRoutes: Routes = [
  {
    path: 'abc',
    component: BookingSectionComponent,
    data: { bookingProduct: 'abc' },
    children: [
      {
        path: 'collection-location',
        component: StepLocationComponent
      },
      // {
      //   path: 'collection-post-office',
      //   component: StepHubDropComponent
      // },
      {
        path: 'collection-time',
        component: StepTimeComponent
      },
      {
        path: 'payment',
        component: StepPaymentComponent
      }
    ]
  },
  {
    path: 'ccd',
    component: BookingSectionComponent,
    data: { bookingProduct: 'ccd' },
    children: [
      {
        path: 'delivery-location',
        component: StepLocationComponent
      },
      {
        path: 'delivery-time',
        component: StepTimeComponent
      },
      {
        path: 'payment',
        component: StepPaymentComponent
      }
    ]
  },
  {
    path: 'redirectingTo',
    component: D2dBookingSwitchComponent
  },
  {
    path: '',
    redirectTo: 'abc/collection-location',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(bookingRoutes)
  ],
  exports: [
    RouterModule
  ]
})

export class BookingRoutingModule { }
